/**
 * NHI Landing Page - cart-aware sticky bar + BYOB picker
 * Loaded only on pages using templates/page.landing.json
 *
 * Tier ladder is read from data attrs on .nhi-sticky-bar so codes/percentages
 * stay configurable from the section settings.
 */
(function () {
  'use strict';

  function readTiers(root) {
    return {
      freeShipCents: parseInt(root.dataset.freeShipCents, 10) || 7000,
      tiers: [
        {
          qty: parseInt(root.dataset.tier1Qty, 10) || 2,
          pct: parseFloat(root.dataset.tier1Pct) || 10,
          code: root.dataset.tier1Code || 'SAVE10'
        },
        {
          qty: parseInt(root.dataset.tier2Qty, 10) || 3,
          pct: parseFloat(root.dataset.tier2Pct) || 15,
          code: root.dataset.tier2Code || 'SAVE15'
        }
      ]
    };
  }

  function fmtUSD(cents) {
    var v = cents / 100;
    return '$' + (v % 1 === 0 ? v.toFixed(0) : v.toFixed(2));
  }

  function activeTier(itemCount, tiers) {
    var hit = null;
    for (var i = 0; i < tiers.length; i++) {
      if (itemCount >= tiers[i].qty) hit = tiers[i];
    }
    return hit;
  }

  function nextTier(itemCount, tiers) {
    for (var i = 0; i < tiers.length; i++) {
      if (itemCount < tiers[i].qty) return tiers[i];
    }
    return null;
  }

  // ---------- Sticky bar ----------
  function fetchCart() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
  }

  function updateStickyBar(cart) {
    var bar = document.querySelector('.nhi-sticky-bar');
    if (!bar) return;
    var cfg = readTiers(bar);
    var itemCount = cart ? cart.item_count : 0;
    var subtotal = cart ? cart.total_price : 0;

    var meta = bar.querySelector('.nhi-sticky-bar-meta');
    var msg = bar.querySelector('.nhi-sticky-bar-msg');
    var cta = bar.querySelector('.nhi-sticky-bar-cta');
    var fill = bar.querySelector('.nhi-sticky-bar-fill');

    var current = activeTier(itemCount, cfg.tiers);
    var next = nextTier(itemCount, cfg.tiers);

    var parts = [];
    if (current) {
      parts.push('🎉 ' + current.pct + '% off unlocked');
    }
    if (next) {
      var need = next.qty - itemCount;
      parts.push('Add ' + need + ' more → ' + next.pct + '% off');
    }
    if (subtotal < cfg.freeShipCents) {
      parts.push(fmtUSD(cfg.freeShipCents - subtotal) + ' to free shipping');
    } else {
      parts.push('🚚 Free shipping');
    }

    if (meta) meta.textContent = 'Cart · ' + itemCount + ' item' + (itemCount === 1 ? '' : 's') + ' · ' + fmtUSD(subtotal);
    if (msg) msg.textContent = parts.join(' · ');

    if (fill) {
      var topQty = cfg.tiers[cfg.tiers.length - 1].qty;
      var pct = Math.min(100, Math.round((itemCount / topQty) * 100));
      fill.style.width = pct + '%';
    }

    if (cta) {
      if (current) {
        cta.href = '/discount/' + current.code + '?redirect=/cart';
        cta.textContent = 'Checkout · ' + current.pct + '% off applied';
      } else if (itemCount > 0) {
        cta.href = '/cart';
        cta.textContent = 'View cart · ' + fmtUSD(subtotal);
      } else {
        cta.href = '#nhi-byob';
        cta.textContent = 'Build your bundle';
      }
    }
  }

  // ---------- BYOB picker ----------
  function initByob() {
    var picker = document.querySelector('.nhi-byob');
    if (!picker) return;
    var cfg = {
      freeShipCents: parseInt(picker.dataset.freeShipCents, 10) || 7000,
      tiers: [
        {
          qty: parseInt(picker.dataset.tier1Qty, 10) || 2,
          pct: parseFloat(picker.dataset.tier1Pct) || 10,
          code: picker.dataset.tier1Code || 'SAVE10'
        },
        {
          qty: parseInt(picker.dataset.tier2Qty, 10) || 3,
          pct: parseFloat(picker.dataset.tier2Pct) || 15,
          code: picker.dataset.tier2Code || 'SAVE15'
        }
      ]
    };
    var tiles = picker.querySelectorAll('[data-variant-id]');
    var counter = picker.querySelector('.nhi-byob-counter');
    var totalEl = picker.querySelector('.nhi-byob-total');
    var tierEl = picker.querySelector('.nhi-byob-tier');
    var cta = picker.querySelector('.nhi-byob-cta');

    function update() {
      var selected = picker.querySelectorAll('[data-variant-id].selected');
      var count = selected.length;
      var totalCents = 0;
      var variants = [];
      selected.forEach(function (t) {
        totalCents += parseInt(t.dataset.priceCents, 10) || 0;
        variants.push(t.dataset.variantId);
      });

      var current = activeTier(count, cfg.tiers);
      var next = nextTier(count, cfg.tiers);
      var discounted = current ? Math.round(totalCents * (1 - current.pct / 100)) : totalCents;

      if (counter) counter.textContent = count + ' selected';
      if (totalEl) {
        if (current && totalCents > 0) {
          totalEl.innerHTML = '<s style="opacity:0.55; margin-right:6px;">' + fmtUSD(totalCents) + '</s>' + fmtUSD(discounted);
        } else {
          totalEl.textContent = fmtUSD(totalCents);
        }
      }
      if (tierEl) {
        if (count === 0) tierEl.textContent = 'Pick 2 → 10% off · 3 → 15% off';
        else if (next) tierEl.textContent = (current ? '🎉 ' + current.pct + '% off · ' : '') + (next.qty - count) + ' more → ' + next.pct + '% off';
        else tierEl.textContent = '🎉 ' + current.pct + '% off unlocked';
      }
      if (cta) {
        if (count >= 1) {
          cta.classList.remove('disabled');
          var cartPath = '/cart/' + variants.map(function (v) { return v + ':1'; }).join(',');
          cta.href = current
            ? '/discount/' + current.code + '?redirect=' + encodeURIComponent(cartPath)
            : cartPath;
          cta.textContent = current
            ? 'Add to cart · ' + current.pct + '% off applied'
            : 'Add to cart · ' + fmtUSD(totalCents);
        } else {
          cta.classList.add('disabled');
          cta.removeAttribute('href');
          cta.textContent = 'Pick at least one';
        }
      }
    }

    tiles.forEach(function (t) {
      t.addEventListener('click', function (e) {
        e.preventDefault();
        t.classList.toggle('selected');
        update();
      });
    });
    update();
  }

  // ---------- Init ----------
  function init() {
    initByob();
    fetchCart().then(updateStickyBar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
